import React from "react";
import { FormControlLabel, Switch } from "@material-ui/core";

export const MetricsSwitch = ({
    checked,
    onChange,
    label,
    labelPlacement = undefined,
    className = undefined,
    disableMetric = false,
    dataTestName,
}) => {
    return (
        <FormControlLabel
            className={className}
            data-test={dataTestName}
            control={<Switch checked={checked} color="primary" onChange={onChange} />}
            label={label}
            labelPlacement={labelPlacement}
            disabled={disableMetric}
        />
    );
};
